import type { MeNavKey } from './me-layout.js'

// The profile sub-views the EmployeeProfileView can render. Other Me sections
// (tasks/worktime/documents) are their own views, dispatched by the /me route.
export type ProfileSection = 'data' | 'time-away' | 'settings'

// Single source of truth for the Me section ↔ URL path ↔ subnav key mapping.
// The empty segment ('') is the /me root (the profile "Andmed" view).
export const ME_SECTIONS: { segment: string; nav: MeNavKey; href: string }[] = [
    { segment: '', nav: 'data', href: '/me' },
    { segment: 'time-away', nav: 'absences', href: '/me/time-away' },
    { segment: 'tasks', nav: 'tasks', href: '/me/tasks' },
    { segment: 'worktime', nav: 'projects', href: '/me/worktime' },
    { segment: 'balancetime', nav: 'worktime', href: '/me/balancetime' },
    { segment: 'assets', nav: 'assets', href: '/me/assets' },
    { segment: 'documents', nav: 'documents', href: '/me/documents' },
    { segment: 'settings', nav: 'settings', href: '/me/settings' },
]

// Maps a /me/:section segment onto the subnav key. Unknown/empty → 'data'.
export const meNavForSection = (section: string | undefined): MeNavKey =>
    ME_SECTIONS.find((entry) => entry.segment === (section ?? ''))?.nav ?? 'data'

// The profile tab to show for a /me section. Only 'time-away' and 'settings'
// are profile tabs; everything else falls back to the 'data' (Andmed) view.
export const profileSectionForPath = (section: string | undefined): ProfileSection =>
    section === 'time-away' ? 'time-away' : section === 'settings' ? 'settings' : 'data'
